import { SET_FAVORITE_EXERCISES, SET_FAVORITE_WORKOUTS, SET_TO_PLAY_FAVORITE } from "./types";
import { apiCallV2 } from "../../../utils/api";

export const GetFavoriteExercise = () => async (dispatch, getState) => {
    const { exercises } = getState().Favorite;
    if (exercises.length === 0) {
        const favorites = await apiCallV2(
            "GET",
            "get-fav-exercise",
            "",
            localStorage.getItem("access-token")
        );


        dispatch({
            type: SET_FAVORITE_EXERCISES,
            list: [...favorites.data.favorites]
        })
    }

}

export const AddFavoriteExercise = (exercise) => async (dispatch, getState) => {
    const { exercises } = getState().Favorite;

    dispatch({
        type: SET_FAVORITE_EXERCISES,
        list: [...exercises, exercise]
    })
}

export const RemoveFavoriteExercise = (videoID) => async (dispatch, getState) => {
    const { exercises } = getState().Favorite;

    dispatch({
        type: SET_FAVORITE_EXERCISES,
        list: [...(exercises.filter(i => i.id !== videoID))]
    })
}

export const GetFavoriteWorkout = () => async (dispatch, getState) => {
    const { workouts } = getState().Favorite;
    if (workouts.length === 0) {
        const favorites = await apiCallV2(
            "GET",
            "get-fav-workout",
            "",
            localStorage.getItem("access-token")
        );


        dispatch({
            type: SET_FAVORITE_WORKOUTS,
            list: [...favorites.data.favorites]
        })
    }

}

export const AddFavoriteWorkout = (workout) => async (dispatch, getState) => {
    const { workouts } = getState().Favorite;

    dispatch({
        type: SET_FAVORITE_WORKOUTS,
        list: [...workouts, workout]
    })
}

export const RemoveFavoriteWorkout = (videoID) => async (dispatch, getState) => {
    const { workouts } = getState().Favorite;

    dispatch({
        type: SET_FAVORITE_WORKOUTS,
        list: [...(workouts.filter(i => i.workout_id !== videoID))]
    })
}

export const Unfavorite = (id, type) => async (dispatch, getState) => {
    const { workouts, exercises } = getState().Favorite;

    let list = (type === "workout") ? workouts : exercises;

    list = list.filter(l => l[type + "_id"] != id)

    dispatch({
        type: type === "workout" ? SET_FAVORITE_WORKOUTS : SET_FAVORITE_EXERCISES,
        list: [...list]
    })
}

export const SetToPlay = (data) => async (dispatch, getState) => {
    const { workouts, exercises } = getState().Favorite;

    dispatch({
        type: SET_TO_PLAY_FAVORITE,
        data: data
    })
}

